<div class="errorView">
  <span>
    The requested page could not be found. Please contact <a href="mailto:support@mvsc.com">support&#64;mvsc
    .com</a> for assistance.
  </span>
</div>
